import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

import {
  ApiUser,
  ApiUserMeta,
  ApiUserMetaUpdate,
  ApiUserUpdate,
} from '~shared/types';

type GetMeOptions = {
  silentAuthFailure?: boolean;
};

export const getMe = async ({
  silentAuthFailure = false,
}: GetMeOptions = {}): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.get(
    'user',
    undefined,
    { _silentAuthFailure: silentAuthFailure },
  );

  return data;
};

export const updateMe = async (user: ApiUserUpdate): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.patch(
    'user',
    user,
  );

  return data;
};

export const getUserMeta = async (): Promise<ApiUserMeta> => {
  const { data }: AxiosResponse<ApiUserMeta> = await HttpService.get(
    'user/meta',
    // 'lessor/user/meta'
  );

  return data;
};

export const updateUserMeta = async (
  userMeta: ApiUserMetaUpdate,
): Promise<ApiUserMeta> => {
  const { data }: AxiosResponse<ApiUserMeta> = await HttpService.patch(
    'user/meta',
    userMeta,
  );

  return data;
};

export const updateEmail = async (email: string): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.post(
    'lessor/user/email-update',
    { email },
  );

  return data;
};

export const verifyEmail = async (): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.post(
    'auth/email-verify',
    {},
  );

  return data;
};

export const confirmEmail = async (token: string): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.post(
    `auth/email-confirm`,
    { token },
  );

  return data;
};

export const updatePhone = async (phone: string): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.post(
    'lessor/user/phone-update',
    { phone },
  );

  return data;
};

export const verifyPhone = async (phone: string): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.post(
    'lessor/user/phone-verify',
    { phone },
  );

  return data;
};

export const confirmPhone = async (
  phone: string,
  code: string,
): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.patch(
    'lessor/user/phone-confirm',
    {
      code,
      // phone
    },
  );

  return data;
};

export const updatePassword = async (
  old_password: string,
  new_password: string,
): Promise<ApiUser> => {
  const { data }: AxiosResponse<ApiUser> = await HttpService.patch(
    'lessor/user/change-password',
    { old_password, new_password },
  );

  return data;
};
